export const actionTypes: any = {
  GET_ALL_NABIL_AUCTION_SUBSCRIBER_START: 'GET_ALL_NABIL_AUCTION_SUBSCRIBER_START',
  GET_ALL_NABIL_AUCTION_SUBSCRIBER_SUCCESS: 'GET_ALL_NABIL_AUCTION_SUBSCRIBER_SUCCESS',
  GET_ALL_NABIL_AUCTION_SUBSCRIBER_FINISH: 'GET_ALL_NABIL_AUCTION_SUBSCRIBER_FINISH',

  GET_NABIL_AUCTION_SUBSCRIBER_START: 'GET_NABIL_AUCTION_SUBSCRIBER_START',
  GET_NABIL_AUCTION_SUBSCRIBER_SUCCESS: 'GET_NABIL_AUCTION_SUBSCRIBER_SUCCESS',
  GET_NABIL_AUCTION_SUBSCRIBER_FINISH: 'GET_NABIL_AUCTION_SUBSCRIBER_FINISH',

  DELETE_NABIL_AUCTION_SUBSCRIBER_START: 'DELETE_NABIL_AUCTION_SUBSCRIBER_START',
  DELETE_NABIL_AUCTION_SUBSCRIBER_SUCCESS: 'DELETE_NABIL_AUCTION_SUBSCRIBER_SUCCESS',
  DELETE_NABIL_AUCTION_SUBSCRIBER_FINISH: 'DELETE_NABIL_AUCTION_SUBSCRIBER_FINISH',

  ENABLE_NABIL_AUCTION_SUBSCRIBER_REQUEST: 'ENABLE_NABIL_AUCTION_SUBSCRIBER_REQUEST',
  ENABLE_NABIL_AUCTION_SUBSCRIBER_SUCCESS: 'ENABLE_NABIL_AUCTION_SUBSCRIBER_SUCCESS',
  ENABLE_NABIL_AUCTION_SUBSCRIBER_FINISH: 'ENABLE_NABIL_AUCTION_SUBSCRIBER_FINISH',

  DISABLE_NABIL_AUCTION_SUBSCRIBER_REQUEST: 'DISABLE_NABIL_AUCTION_SUBSCRIBER_REQUEST',
  DISABLE_NABIL_AUCTION_SUBSCRIBER_SUCCESS: 'DISABLE_NABIL_AUCTION_SUBSCRIBER_SUCCESS',
  DISABLE_NABIL_AUCTION_SUBSCRIBER_FINISH: 'DISABLE_NABIL_AUCTION_SUBSCRIBER_FINISH',

  SINGLE_ENABLE_NABIL_AUCTION_SUBSCRIBER_REQUEST: 'SINGLE_ENABLE_NABIL_AUCTION_SUBSCRIBER_REQUEST',
  SINGLE_ENABLE_NABIL_AUCTION_SUBSCRIBER_SUCCESS: 'SINGLE_ENABLE_NABIL_AUCTION_SUBSCRIBER_SUCCESS',
  SINGLE_ENABLE_NABIL_AUCTION_SUBSCRIBER_FINISH: 'SINGLE_ENABLE_NABIL_AUCTION_SUBSCRIBER_FINISH',

  SINGLE_DISABLE_NABIL_AUCTION_SUBSCRIBER_REQUEST: 'SINGLE_DISABLE_NABIL_AUCTION_SUBSCRIBER_REQUEST',
  SINGLE_DISABLE_NABIL_AUCTION_SUBSCRIBER_SUCCESS: 'SINGLE_DISABLE_NABIL_AUCTION_SUBSCRIBER_SUCCESS',
  SINGLE_DISABLE_NABIL_AUCTION_SUBSCRIBER_FINISH: 'SINGLE_DISABLE_NABIL_AUCTION_SUBSCRIBER_FINISH',
}
